import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

export const New = () => {
  const { t } = useTranslation();
  return (
    <span className="relative -top-1 text-[0.5rem] uppercase bg-orange text-white rounded-sm px-1 py-0.5 leading-none font-bold mb-1 mr-1">
      {t('new')}
    </span>
  );
};
